import { useEffect, useState } from "react";
import { createContext } from "react";

export const UserContext = createContext({
  user: "",
});
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState("");
  useEffect(() => {
    if (localStorage.getItem("user")) {
      setUser(localStorage.getItem("user"));
    }
  }, []);
  const value = { user, setUser };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
